import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import imagesWithBlurSchema from '@utils/validate/blocksSchemes/imagesWithBlurSchema';
import videoMediaSchema from '@utils/validate/blocksSchemes/videoMediaSchema';
import thumbnailsWithBlurSchema from '@utils/validate/blocksSchemes/thumbnailsWithBlurSchema';
const visualBlockSchema = Joi.object({
  type: Joi.string().valid('visualBlock').required(),
  code: Joi.string().allow('', null).required(),
  header: Joi.string().allow('', null).required(),
  headerColor: Joi.string().allow('', null).required(),
  headerBackgroundColor: Joi.string().allow('', null).required(),
  images: mediaUrlSchema.required(),
  imagesWithBlur: imagesWithBlurSchema,
  subHeader: Joi.string().allow('', null).required(),
  voxboxButton: Joi.boolean().allow('', null).required(),
  videos: videoMediaSchema.required(),
  thumbnailsWithBlur: thumbnailsWithBlurSchema
}).unknown(true);
export default visualBlockSchema;